import React, { useEffect, useState } from "react";


const Success = () => {
  const [sessionId, setSessionId] = useState(null);
  const [paymentIntent, setPaymentIntent] = useState(null);

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.split("?")[1]);
    const sessionIdFromURL = hashParams.get("sessionId");
    setSessionId(sessionIdFromURL);
  }, []);

  
 
  useEffect(() => {
    const sendEmailToUser = async () => {
      if (sessionId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/send-mail`,
            {
              method: "POST",
              headers: { "Content-type": "application/json" },
              body: JSON.stringify({ sessionId }),
            }
          );
          const data = await response.json();
          setPaymentIntent(data.data);
        } catch (error) {
         
        }
      }
    };
    sendEmailToUser();
  }, [sessionId]);


  const navigateToCustomerPortal = async () => {
    if (!sessionId) {
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/customer-portal`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ sessionId }),
        }
      );
      const { url } = await response.json();
      if (url) {
        window.location.href = url;
      }
    } catch (error) {
     
    }
  };


   const navigateToHomePage = () => {
    window.location.href = "https://www.automateaccounts.com/";
  };
  const navigateToInvoice = async () => {
    if (!sessionId) {
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/fetch-invoice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ sessionId }),
        }
      );

      const { url } = await response.json();
      if (url) {
        window.location.href = url;
      }
    } catch (error) {
     
    }
  };
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md px-4 sm:px-6 md:px-8">
        <div className="flex justify-center mb-6">
          <div className="bg-green-500 rounded-full p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              className="w-16 h-16 text-green-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Payment Successful!
        </h1>
        <p className="text-center w-full mb-6">
          Thank you for your payment. Your transaction has been successfully processed.
          <br />
          {
              paymentIntent &&
              <span className="">
           
              <strong>Reference ID:</strong>
              <span>
                {paymentIntent}
              </span>
            </span>

            }
       

        </p>
        <div className="flex flex-col space-y-4 sm:flex-row sm:space-x-4 items-center justify-center">
          <button
            onClick={navigateToHomePage}
            className="bg-customRed text-white py-4 mt-4 rounded-lg text-[16px] min-w-[150px]"
          >
            Return to Home
          </button>
          <button
            onClick={navigateToCustomerPortal}
            className="bg-customRed text-white py-4 mt-4 rounded-lg text-[16px] min-w-[150px]"
          >
            Customer Portal
          </button>
          <button
            onClick={navigateToInvoice}
            className="bg-customRed text-white py-4 mt-4 rounded-lg text-[16px] min-w-[150px]"
          >
            Download Invoice
          </button>
        </div>
      </div>
    </div>
  );
  
};

export default Success;
